import React, {useState,useEffect} from 'react'
import { useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import { post } from '../../Services/Api';
import { notification } from 'antd';
import { Link } from 'react-router-dom';
import eyeClose from '../../Assets/images/eyeclose.svg'
import eyeOpen from '../../Assets/images/eyeopen.svg'

const Login = () => {
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const openNotification = (type, message, description) => {
    notification[type]({
      message,
      description,
      placement: 'topRight',
    });
  };

  useEffect(() => {
    // Clear localStorage when on the Login page
    localStorage.removeItem("emailEntered");
    localStorage.removeItem("adminId");
    localStorage.removeItem("firstName");
    localStorage.removeItem("roles");
    localStorage.removeItem("accessToken");
  }, []);

  // const handleFormSubmit = (e)=>{
  //   e.preventDefault();

  //   if (username === "superadmin" && password === "superadmin") {
  //     const dummyToken = "12345qwerty";
  //     const userId="superadmin";
  //     localStorage.setItem("dummyToken",dummyToken);
  //     localStorage.setItem("userId",userId);
  //     navigate('spaceSelect/planning-to-theater');
    
  //   }else if(username === "admin" && password === "admin"){
  //     const dummyToken = "12345qwerty";
  //     const userId="admin";
  //     localStorage.setItem("dummyToken",dummyToken);
  //     localStorage.setItem("userId",userId);
  //     navigate('/spaceSelect');
  //   }else{
  //     localStorage.removeItem("dummyToken");
  //     localStorage.removeItem("userId");
  //     navigate('/');
  //     alert("Invalid credential!!!")
  //   }
  // }

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Define the payload with the username and password
    const payload = {
      username,
      userpassword: password,
    };

    try {
      // Call the login API using the custom post method
      const response = await post('login', payload);

      if (response && response.data) {
        const { access_token, admin_id, first_name,roles } = response.data.data;

        // Store token and other details in localStorage
        localStorage.setItem('accessToken', access_token);
        localStorage.setItem('adminId',admin_id);
        localStorage.setItem('firstName', first_name);
        localStorage.setItem('roles', roles);
        // navigate('/spaceSelect');

        // Navigate based on admin_id
        // if (admin_id === 1) {
        //   navigate('/spaceSelect/planning-to-theater');
        // } else if (admin_id === 2) {
        //   navigate('/spaceSelect');
        // }
        if (roles === "admin") {
          navigate('/spaceSelect/planning-to-theater');
        } else if (roles === "user") {
          // navigate('/spaceSelect');
          navigate('/spaceSelect/planning-to-theater');
        }
      } else {
        openNotification('error', 'Login Failed', response.message || 'Invalid credentials');
      }
    } catch (error) {
      // openNotification('error', 'Error', 'An error occurred while trying to log in. Please try again.');
      if (error.response && error.response.status === 401){
        openNotification('error','Login Failed',error.response.data.error || "Invalid credentials")
      }else{
        openNotification(
        "error",
        "Error",
        "An error occurred while trying to log in. Please try again."
        )
      }
    }
  };

  // const handleForgotPassword = ()=>{
  //   navigate('forgot-password')
  // }


  return (
    <div className="position-relative login-bg">
      {/* <div className="login-bg"></div> */}
      <div className="container vh-100">
        <div className="row align-items-center h-100">
          <div className="col-lg-6">
              <div className="bg-white login-main-box">
                  <h4 className="heading">SHARED PARKING</h4>

                  <h3 className="title">
                    Login to your account
                  </h3>
                  <form onSubmit={handleFormSubmit}>
                  <div className="form-group mb-2">
                    <label htmlFor="">
                      {/* Username or  */}
                       Email</label>
                    <input type="text" className="form-control" value={username} onChange={e =>setUsername(e.target.value)}/>
                  </div>
                  <div className="form-group mb-2">
                    <label htmlFor="">Password</label>
                    <div className="position-relative">
                    <input type={`${showPassword ? "text" : "password"}`} className="form-control"   value={password} onChange={e =>setPassword(e.target.value)}/>
                    <div
                  className="icon-eye"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  style={{
                    top:'12px'
                  }}
                >
              
                  <img src={showPassword ? eyeOpen : eyeClose} alt="" style={{width:'15px'}} />
                </div>
                    </div>
                  </div>
                  <div className="text-end">
                    {/* <a href="" onClick={handleForgotPassword} className="forgot">Forgot Password?</a> */}
                    <Link to="/forgot-password" className="forgot">
                      Forgot Password?
                    </Link>
                  </div>
                  <button className="btn btn-primary w-100 my-3">
                    Sign In
                  </button>
                  </form>
                  {/* <p className="text-center sign-up-below">
                    Don't have an account? <a href="">Sign up </a> 
                  </p> */}
              </div>
          </div>
          <div className="col-lg-6">

          </div>
        </div>
      </div>
    </div>
  )
}

export default Login